/**
 * 공지사항 관련 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class CommunityNoticeService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 활성 공지사항 조회
     * 활성화된 공지사항을 페이지네이션과 검색 필터를 적용하여 조회합니다. 제목과 카테고리로 필터링할 수 있으며, 최신순으로 정렬됩니다.
     * @param searchRequest - 공지사항 검색 조건
     * @param pageable - 페이지네이션 및 정렬 정보
     * @returns 활성 공지사항 조회 결과
     */
    getActiveNotices(searchRequest, pageable) {
        return this.axios.get(`/co/v1/support/notices`, {
            params: {
                ...searchRequest,
                ...pageable,
            },
        });
    }
    /**
     * 공지사항 상세 정보를 조회합니다.
     * 공지사항 ID를 통해 상세 정보를 조회합니다. 조회 시 조회수가 증가하며, 첨부파일 정보도 함께 제공됩니다.
     * @param id - 조회할 공지사항의 ID
     * @returns 공지사항 상세 정보를 조회합니다. 결과
     */
    getNoticeDetail(id) {
        return this.axios.get(`/co/v1/support/notices/${id}`);
    }
    /**
     * 상단에 고정된 공지사항을 조회합니다.
     * 상단에 고정된 공지사항 목록을 조회합니다. 고정된 공지사항은 일반 공지사항보다 우선적으로 표시됩니다.
     */
    getNoticePinned() {
        return this.axios.get(`/co/v1/support/notices/pinned`);
    }
}
//# sourceMappingURL=notice.service.js.map